import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

import { PropType, defineAsyncComponent, computed } from 'vue'

type InputMode = 'default' | 'other'


export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'v-input'
},
  __name: 'VInput',
  props: {
    mode: {
        type: String as PropType<InputMode>,
        required: false,
        default: 'default'
    },
},
  setup(__props) {



const props = __props

const capitalizedMode = computed(() => props.mode?.toCapitalize?.())

const asyncComponent = defineAsyncComponent(async () => {
  const { default: component } = await import(`./${capitalizedMode.value}Input.vue`);
  return component;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_KeepAlive, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(asyncComponent)), _normalizeProps(_guardReactiveProps(_ctx.$props)), _createSlots({ _: 2 }, [
      _renderList(_ctx.$slots, (_, name) => {
        return {
          name: name,
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, name)
          ])
        }
      })
    ]), 1040))
  ], 1024))
}
}

})